import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import venderThumb from "../images/vender-1.svg";

import profileThumb from "../images/profileThumb.png";
import itemThumb from "../images/itemThumb.svg";
import itemProfile from "../images/itemProfile.svg";
import { postRecoverPassword, loggedIn } from "./API Functions";


function Recover() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const [emailError, setEmailError] = useState("");

    useEffect(() => {
    }, [])

    function validateFields() {
        let emailError = ""

        if (email == "") {
            emailError = "El correo no puede ser vacío."
        }

        if (emailError) {
            setEmailError(emailError);
            return false
        } else {
            setEmailError(emailError);
            return true
        }
    }
    function Submit() {
        setLoading(true);
        const data = {
            email: email,
        };

        const isValid = validateFields()
        if (isValid) {
            postRecoverPassword(data).then(res => {
                if (!res) {
                    setEmailError("No pudimos encontrar una cuenta con este correo.");
                    setTimeout(() => {
                        setLoading(false);
                        setEmailError("");
                    }, 2000);
                } else {
                    window.location.replace('/login')
                }
            })
        }
    }
    return (
        <div>
            <div className="loginContainer">
                <div className="loginContainer-nav">

                    <div className="loginContainer-nav__item">


                        <Link to="/" className="loginContainer-nav__itemBack">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 5L4 10L9 15" stroke="#111111" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4 10L16 10" stroke="#111111" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <p>Regresar</p>
                        </Link>
                    </div>
                    <div className="loginContainer-nav__item">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                                <path d="M22.5925 16.8231C23.9383 16.8904 25.0654 15.8137 25.0654 14.468V12.1633C25.0654 11.8773 25.4019 11.7259 25.6206 11.9109L30.9869 16.3016C31.4243 16.6549 31.9458 16.8399 32.4841 16.8399C33.1738 16.8399 33.8467 16.5371 34.3009 15.982C35.1252 14.9726 34.9738 13.4923 33.9645 12.668L29.4224 8.9502C29.086 8.68104 29.086 8.17636 29.4224 7.90721L33.9645 4.18945C34.9738 3.36515 35.1252 1.88478 34.3009 0.875431C33.4766 -0.133915 31.9963 -0.285317 30.9869 0.538982L25.6206 4.92964C25.4019 5.11468 25.0654 4.94646 25.0654 4.6773V2.42309C25.0654 1.16141 24.0897 0.067954 22.828 0.000664339C21.4822 -0.0666254 20.3551 1.01001 20.3551 2.3558V14.4007C20.3551 15.6623 21.3308 16.7558 22.5925 16.8231ZM13.4075 19.1782C12.0617 19.1109 10.9346 20.1876 10.9346 21.5334V23.838C10.9346 24.124 10.5981 24.2754 10.3794 24.0904L5.01308 19.6997C4.5757 19.3465 4.05421 19.1614 3.51589 19.1614C2.82617 19.1614 2.15327 19.4642 1.69907 20.0194C0.874766 21.0287 1.02617 22.5091 2.03551 23.3334L6.57757 27.0511C6.91402 27.3203 6.91402 27.825 6.57757 28.0941L2.03551 31.8119C1.02617 32.6362 0.874766 34.1165 1.69907 35.1259C2.52336 36.1352 4.00374 36.2866 5.01308 35.4623L10.3794 31.0717C10.5981 30.8866 10.9346 31.0549 10.9346 31.324V33.5614C10.9346 34.8231 11.9103 35.9165 13.172 35.9838C14.5178 36.0511 15.6449 34.9745 15.6449 33.6287V21.5838C15.6449 20.339 14.6692 19.2455 13.4075 19.1782ZM8.41121 0.000664339C3.76822 0.000664339 0 3.76889 0 8.41188C0 13.0549 3.76822 16.8231 8.41121 16.8231C13.0542 16.8231 16.8224 13.0549 16.8224 8.41188C16.8224 3.76889 13.0542 0.000664339 8.41121 0.000664339ZM8.41121 12.1128C6.3757 12.1128 4.71028 10.4474 4.71028 8.41188C4.71028 6.37636 6.3757 4.71094 8.41121 4.71094C10.4467 4.71094 12.1122 6.37636 12.1122 8.41188C12.1122 10.4474 10.4467 12.1128 8.41121 12.1128ZM33.6449 25.2343H21.5327C20.2374 25.2343 19.1776 26.2941 19.1776 27.5894C19.1776 28.8848 20.2374 29.9446 21.5327 29.9446H33.6449C34.9402 29.9446 36 28.8848 36 27.5894C36 26.2941 34.9402 25.2343 33.6449 25.2343Z" fill="#111111" />
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <rect width="36" height="36" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </div>
                    <div className="loginContainer-nav__item">
                        <Link to="/login" className="button button-alpha">
                            Iniciar sesión
                    </Link>
                    </div>

                </div>
                <div className="loginContainer-form">
                    <div className="loginContainer-card">
                        <h3 className="loginContainer-card__title">
                            Recuperar contraseña
      </h3>
                        <div className="loginContainer-card__input">
                            <input type="email" className="input" placeholder="Correo electrónico" value={email} onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className="fieldError">{emailError}</div>
                        <div className="loginContainer-card__row loginContainer-card__rowActions">
                            <div className="loginContainer-card__row"></div>
                            <button className="button u-pull-right aButton" onClick={Submit}>
                                Enviar instrucciones
       </button>
                        </div>
                    </div>
                    <Link to="/login" className="button button-alpha">
                        Iniciar sesión
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Recover;
